import React from "react";
import {Box, Button, Typography, Dialog, Link} from "@mui/material";
import {useTranslation} from "react-i18next";
import PropTypes from 'prop-types';

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
    privacyLink: {
        color: '#006DB7',
        fontSize: 16,
        fontWeight: 400,
        textDecoration: "none",
        cursor: "pointer"
      },
  }));


const DataCollectionPopUp = ({ onClose, open }) => {
    const {classes} = MaskSelectorToolStyles();
    const {classes: localClasses} = useStyles();
    const { t } = useTranslation("pages.MaskSelectorTool.ChooseMaskSizingMethod");
    const closePopupButton = t("closePopupButton");

    const dataCollectionHeader = t("dataCollectionHeader");
    const dataCollectionBody = t("dataCollectionBody");
    const dataCollectionLink = t("dataCollectionLink");

    return (
        <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
            <Box>
                <Box width="335px" height={"344px"} p={2} className={classes.optionCardPopupBox}> 
                    <Box width="287px" height="254px" sx={{display: "flex", flexDirection: "column", gap: 2}}>
                        <Typography className={`${classes.res_survey_header}`}>{dataCollectionHeader}</Typography>
                        <Typography className={`${classes.subHeadingTyp}`} tabIndex="0" aria-label={dataCollectionBody}>{dataCollectionBody}</Typography>
                        <Link href="privacy-policy" target="_blank" className={`${localClasses.privacyLink}`} sx={{fontWeight: 400}} tabIndex="0" aria-label={dataCollectionLink}>{dataCollectionLink}</Link>
                    </Box>
                    <Box mt="20px">
                        <Button
                            sx={{height: "40px"}}
                            disableRipple
                            variant="contained"
                            color="secondary"
                            onClick={onClose}
                        >{closePopupButton}</Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
)}

DataCollectionPopUp.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
}

export default DataCollectionPopUp;